<template>
      <w-notification
      color="error"
      bg-color="error-light5"
      v-show="store.errorLogin"
      error
      plain
      shadow
      transition="bounce"
      :top="true"
      :center="true">
        <span class="flex ma3 pa5">
          Login failed check username or password
       </span>
          <icon class="mdi mdi-close close-icon" 
           @click="store.errorLogin = false">
          </icon>
    </w-notification>
  <div id="loginForm">
    <div v-if="store.currentUser.isLoggedIn">
      <div class="w-flex align-center">
        <div class="xs8">
          <w-input
            class="mb2"
            label="Utente"
            type="text"
            inner-icon-left="mdi mdi-account"
            v-model="store.currentUser.username"
            readonly
          >
          </w-input>
          <w-input
            class="mb2"
            label="Azienda"
            type="text"
            inner-icon-left="mdi mdi-warehouse"
            v-model="store.currentUser.company"
            readonly
          >
          </w-input>
        </div>
        <div class="xs4">
          <!-- Change with redirect in vue -->
          <w-button @click="logOut()"> Logout </w-button>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="w-flex align-center">
        <div class="xs8" @keyup.enter="logIn()">
          <w-input
            class="mb2"
            label="Username"
            type="text"
            inner-icon-left="mdi mdi-account"
            v-model="store.authentication.username"
            :validators="[validators.required]"
          ></w-input>
          <!-- @keyup.enter="logIn(store.currentUser.authentication.username, store.currentUser.authentication.password, this.$router)" -->
          <w-input
            class="mb2"
            label="Password"
            :type="isPassword ? 'password' : 'text'"
            :inner-icon-left="isPassword ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"
            @click:inner-icon-left="isPassword = !isPassword"
            v-model="store.authentication.password"
            :validators="[validators.required]"
          ></w-input>
          <!-- @keyup.enter="logIn(store.currentUser.authentication.username, store.currentUser.authentication.password, this.$router)" -->
        </div>
        <div class="xs4">
          <!-- se i model puntano allo store non serve che ritornino ne metodo e il router è nello store non come parameter -->
          <w-button @click="logIn()" :disabled="!store.isLoginEnabled()">
            Login
          </w-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@mdi/font/css/materialdesignicons.min.css";
import { store } from "@/utils/store";
import { computed } from "vue";
import router from "@/router";

export default {
  name: "LoginForm",
  data() {
    return {
      store,
      isPassword: true,
      validators: {
        required: (value) => !!value || "This field is required",
      },
    };
  },

  setup: () => {
    const error= computed(() => store.errorLogin);
    
    const destination = computed(() => {
      if (store.destination != null || store.destination != undefined) {
        store.destination =
          store.destination == "/" ? "/monitoring-map" : store.destination;
        return store.destination;
      } else {
        return "/monitoring-map";
      }
    });

    async function logIn() {
      store.startLoading();
      await store.login().then((result) => {
        console.log(result, destination.value);
        if (result.isLoggedIn) {
          store.errorLogin = false;
          router.push(destination.value);
        }
      });
      store.stopLoading();
    }

    function logOut() {
      store.startLoading();
      store.logout();
      router.push("/");
      store.stopLoading();
    }

    return { logIn, logOut,error };
  },
};
</script>

<style scoped>
.close-icon {
  cursor: pointer;
  float: right;
}
</style>
